import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';
import type { TasAssetExtension as TasAssetModel } from 'tio-data/data/resources/tas-asset.ext';

/**
 * Returns deduplicated assets from program, course, application, and payment relationships.
 * Includes deleted assets for history displays; uploaders apply their own live-asset filter.
 */
export function collectApplicationAssets(application: TasApplicationModel): TasAssetModel[] {
  const programInstanceAssets = application.tasProgramInstance?.tasAssets ?? [];
  const courseAssets = application.activeCourses?.flatMap((course) => course.tasAssets ?? []) ?? [];
  const appAssets = application.tasAssets ?? [];
  const assistanceAssets =
    application.tasAssistances?.flatMap((assistance) => assistance.tasAssets ?? []) ?? [];

  const seenIds = new Set<string>();
  const allAssets = [...programInstanceAssets, ...courseAssets, ...appAssets, ...assistanceAssets];
  return allAssets.filter((asset) => {
    const id = asset.id;
    if (!id || seenIds.has(id)) {
      return false;
    }
    seenIds.add(id);
    return true;
  });
}
